import {
    HTMLAttributes,
    ReactElement
  } from "react";
interface Props extends HTMLAttributes<HTMLElement> {
    title: string;
    value: string;
    myStyle?: string;
}
export function ProfileInfo({ title, value , myStyle}: Props): ReactElement {
    return (
        <div className={`${myStyle && myStyle} profile-info`}>
            <h5 className="title">
                {title}
            </h5>
            <h6 className="value">
                {value || `---`}
            </h6>
        </div>
    )
}
export default ProfileInfo;


